import { useEffect } from "react";

/**
 * Injects schema.org JSON-LD into <head>. Each instance owns a unique <script>
 * tagged with data-jsonld="<id>"; remounts replace cleanly so route changes
 * never leak stale schema into the document.
 *
 * Usage:
 *   <JsonLd id="home-org" data={{ "@context": "https://schema.org", "@type": "Organization", ... }} />
 */
export default function JsonLd({ id, data }) {
  useEffect(() => {
    if (!data) return;
    const selector = `script[data-jsonld="${id}"]`;
    let el = document.querySelector(selector);
    if (!el) {
      el = document.createElement("script");
      el.type = "application/ld+json";
      el.setAttribute("data-jsonld", id);
      document.head.appendChild(el);
    }
    try {
      el.textContent = JSON.stringify(data);
    } catch {
      // ignore serialization issues
    }
    return () => {
      const node = document.querySelector(selector);
      if (node) node.remove();
    };
  }, [id, data]);
  return null;
}
